export default __webpack_public_path__ + "static/media/gs-back.8b3631fc.png";